import styled from "styled-components";
import { useFocused, useSelected, useReadOnly, PlateElement } from "@platejs/core/react";
import { withRef } from "@udecode/cn";

import { Color } from "~/shared/styles";

export const HrElement = withRef<typeof PlateElement>((props, ref) => {
	const readOnly = useReadOnly();
	const focused = useFocused();
	const selected = useSelected();

	return (
		<PlateElement ref={ref} {...props}>
			<Container contentEditable={false}>
				<Hr $offset={focused && selected} $readOnly={readOnly} />
			</Container>
			{props.children}
		</PlateElement>
	);
});

const Container = styled.div`
	padding: 0 1rem;
`;

const Hr = styled.hr<{ $offset: boolean; $readOnly: boolean }>`
	background-color: ${Color.BORDER_LINE_DARK};
	border-radius: 2px;
	border-style: none;
	cursor: ${({ $readOnly }) => ($readOnly ? "default" : "pointer")};
	height: 2px;
	
	${({ $offset }) =>
		$offset &&
		`
		outline: 2px solid ${Color.BORDER_LINE_DARK};
	`}
`;

HrElement.displayName = "HrElement";
